<script>
import tableSearch from "@/mixins/tableSearch";
import sweetAlert from "@/mixins/sweetAlert";

export default {
  props: {
    work_reservations: {
      type: Array,
      default: () => {}
    },
    case_id: {
      type: Number,
      default: 0
    },
  },
  components: {
    CommonTableComponent: () => import('@/components/table.vue'),
  },
  mixins: [tableSearch, sweetAlert],
  methods: {
    edit(item) {
      this.$emit('edit', item);
    },
    getWasteOrServiceName(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(item => item.name || '').join('<br>');
    },
    getWasteCategoryOfTreatment(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(item => item.waste_category_of_treatment_name_abbreviated || '').join('<br>');
    },
    getVendorSiteOfTreatment(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(item => item.vendor_sites_name_abbreviated || '').join('<br>');
    },
    getTreatmentMethod(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(item => item.treatment_method || '').join('<br>');
    },
    getNumberOfManifest(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(item => item.number_of_manifests || '').join('<br>');
    },
    getEstimateCds(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(
        item =>
          item.waste_estimates_by_work_reservation.filter(estimate => estimate.reservation_quantity > 0)
          .map(estimate => estimate.estimate_cd || '').join('<br>')
      ).join('<br>');
    },
    getPlannedUnitOfMeasure(work_reservation) {
      if (!work_reservation || !work_reservation?.wastes_or_services_by_work_reservation) return '';

      return work_reservation.wastes_or_services_by_work_reservation.map(waste_or_service => {
        return waste_or_service.waste_estimates_by_work_reservation
         .filter(estimate => estimate.reservation_quantity > 0).map(item => {
          const reservationQuantity = this.$n(item.reservation_quantity);
          const unit = item?.zz_unit?.unit;

          return `${reservationQuantity}${unit}`;
        });
      }).filter(item => !!item).join('<br>');
    },
    getWasteJwPackingType(work_reservation) {
      return work_reservation.wastes_or_services_by_work_reservation.map(item => item.jw_packing_type ?? '').join('<br>');
    },
    async remove(work_reservation) {
      this.confirm(
        '',
        '',
        '削除してよろしいですか？<br>よろしければ削除ボタンを押してください。'
      ).then(async (result) => {
        if (!result.isConfirmed) return;

        this.$emit('reservationDeleted', work_reservation.id);
      });
    },
    getDayOfTimeZoneLabel(reservationDate) {
      return this.$constant.ZZ_DAY_OF_TIME_ZONE_LABEL[reservationDate.zz_day_of_time_zone_id] || '';
    }
  },
  computed: {
    headers() {
      return this.$constant.tableHeaders.work_reservation.reservation_reflected;
    },
  },
}
</script>

<template>
  <div>
    <CommonTableComponent :height-class="`table-wrapper-500`">
      <thead class="table-light">
      <tr>
        <th
          v-for="(item, index) in headers"
          :key="index"
          :class="[...getHeaderClass(item), 'text-center']"
        >
          <span v-html="item.text"> </span>
        </th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(work_reservation, index_work_reservation) in work_reservations">
        <tr
          v-for="(reservation_date, index_date) in work_reservation.reservation_dates_by_work_reservation"
          :key="`date_${index_work_reservation}_${index_date}`"
        >
          <td>{{ reservation_date.work_reservation_date | longDate }}</td>
          <td>{{ getDayOfTimeZoneLabel(reservation_date) }}</td>
          <template v-if="index_date === 0">
            <td class="text-center" :rowspan="work_reservation.reservation_dates_by_work_reservation.length">
              {{ work_reservation.work_order_id }}
            </td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
                v-html="getWasteCategoryOfTreatment(work_reservation)">
            </td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
                v-html="getWasteOrServiceName(work_reservation)">
            </td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
                v-html="getNumberOfManifest(work_reservation)">
            </td>
            <td
              :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
              v-html="getEstimateCds(work_reservation)"
            >
            </td>
            <td
              :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
              v-html="getWasteJwPackingType(work_reservation)"
            >
            </td>
            <td
              :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
              v-html="getPlannedUnitOfMeasure(work_reservation)"
            >
            </td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
                v-html="getVendorSiteOfTreatment(work_reservation)">
            </td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length"
                v-html="getTreatmentMethod(work_reservation)">
            </td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length">{{ reservation_date.zz_reservation_type.reservation_type }}</td>
            <td :rowspan="work_reservation.reservation_dates_by_work_reservation.length" class="text-center">
              <div class="d-flex align-self-center justify-content-between">
                <b-button variant="primary" @click="edit(work_reservation)" class="text-nowrap"><i class='fas fa-edit'></i> 編集</b-button>
                <b-button variant="danger" @click="remove(work_reservation)" class="text-nowrap">削除</b-button>
              </div>
            </td>
          </template>
        </tr>
      </template>
      </tbody>
    </CommonTableComponent>
  </div>
</template>

<style lang="scss" scoped>

</style>
